jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

    const variants = JSON.parse(document.querySelector("script.pr_variants_json").textContent);
    const backorder_note = document.querySelector("input#bl_backorder_note");
    const backorder_desc = document.querySelector(".bl_backorder");
    for (const item of document.querySelectorAll('.t4s-swatch__item')) {
      item.addEventListener('click', function () {
        setTimeout(() => {
          const selectedOptions = document.querySelectorAll('.t4s-swatch__item.is--selected');
          const variant_title = [];
          for (let option of selectedOptions) {
            variant_title.push(option.dataset.value);
          }
          
          const v = variants.find(v => v.title === variant_title.join(' / '));
          if (v.available && v.inventory_quantity <= 0 && v.inventory_policy == 'continue') {
            backorder_desc.style.display = "block";
            backorder_note.value = "Backorder";
          } else {
            backorder_desc.style.display = "none";
            backorder_note.value = "";
          }
        }, 0)
      });
    }
});